<script setup lang="ts">
import type { ClassValue } from 'tailwind-variants';
import { DrawerHandle } from 'vaul-vue';
import { cn } from '@/lib/utils';

const props = withDefaults(defineProps<{
    class?: ClassValue;
}>(), {
    class: undefined,
});
</script>

<template>
    <DrawerHandle
        data-slot="handle"
        :class="cn(
            'shrink-0 rounded-full bg-gray-300',
            'data-[vaul-drawer-direction=top]:mb-2 data-[vaul-drawer-direction=top]:h-1.5 data-[vaul-drawer-direction=top]:w-12 data-[vaul-drawer-direction=top]:self-center',
            'data-[vaul-drawer-direction=bottom]:mt-2 data-[vaul-drawer-direction=bottom]:h-1.5 data-[vaul-drawer-direction=bottom]:w-12 data-[vaul-drawer-direction=bottom]:self-center',
            'data-[vaul-drawer-direction=left]:ml-2 data-[vaul-drawer-direction=left]:h-12 data-[vaul-drawer-direction=left]:w-1.5 data-[vaul-drawer-direction=left]:self-center',
            'data-[vaul-drawer-direction=right]:mr-2 data-[vaul-drawer-direction=right]:h-12 data-[vaul-drawer-direction=right]:w-1.5 data-[vaul-drawer-direction=right]:self-center',
            props.class,
        )"
    />
</template>
